module.exports = __webpack_public_path__ + "img/partner.324edb31.png";